import { Pipe, PipeTransform } from '@angular/core';

const URL_REGEX = /(https?:\/\/[^\s<>"]+)/g;

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

@Pipe({
  name: 'linkify',
  standalone: true,
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value === null || value === undefined) return '';
    return value
      .split(URL_REGEX)
      .map((part, i) =>
        i % 2 === 1 ? `<a class="post-link" href="${part}">${escapeHtml(part)}</a>` : escapeHtml(part),
      )
      .join('');
  }
}
